import { Box, Stack, SvgIconProps, Typography } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactNode, SVGProps } from 'react';
import * as React from 'react';
import { palette } from '../../../../../../../theme';

const iconWidth = 24;
const spacingPx = 8;

export interface ITextContent {
  content: string;
  isBold?: boolean;
  keepSize?: boolean;
}

export interface IIconWithContentProps {
  Icon: React.FC<SvgIconProps> | React.FC<SVGProps<SVGSVGElement>>;
  textContent?: ITextContent;
  children?: ReactNode;
  isActive?: boolean;
  isAlignCentered?: boolean;
  hasIconOffset?: boolean;
}

export function IconWithContent(props: IIconWithContentProps) {
  const color = props.isActive ? 'primary' : 'secondary';
  const textColor = props.isActive ? palette.primary.main : palette.secondary.main;
  const spacing = props.textContent?.isBold ? 1 : 2;
  return (
    <Stack
      direction="row"
      sx={{
        alignItems: props.isAlignCentered ? 'center' : undefined,
        width: `calc(100% - ${iconWidth}px - ${spacing * spacingPx}px)`,
      }}
      spacing={spacing}
    >
      <Box sx={{ fontSize: 0, pt: props.hasIconOffset ? 0.5 : undefined }}>
        <SvgIcon component={props.Icon} color={color} />
      </Box>
      {props.textContent ? (
        <Typography
          sx={{ color: textColor, fontWeight: props.textContent.isBold ? palette.fontWeight.bold : undefined }}
          variant={props.textContent.isBold || props.textContent.keepSize ? 'body1' : 'body2'}
        >
          {props.textContent.content}
        </Typography>
      ) : (
        props.children
      )}
    </Stack>
  );
}
